import React, { useState } from "react";
import dayjs from "dayjs";
import Sidebar from "../Sidebar";
import Layout from "../Layout";
import FilterBar from "../AdminDashboard/FilterBar";
import ProductAnalyticsWidget from "./ProductAnalyticsWidget";
import DropoffExplorerWidget from "./DropoffExplorerWidget";
import LocationBreakdownWidget from "./LocationBreakdownWidget";
import UserTimelineWidget from "./UserTimelineWidget";
import { useAuthz } from "../../auth/useAuthz";

// Standalone tab for in-house product analytics (screen/funnel/error events
// from the user app) — kept separate from the operational AdminDashboard so
// booking-ops and product metrics don't get mixed on one page.
const AdminProductAnalytics = () => {

  const { can } = useAuthz();
  const [filters, setFilters] = useState(() => {
    const today = dayjs().format("YYYY-MM-DD");
    return { startDate: today, endDate: today };
  });
  const [refreshKey, setRefreshKey] = useState(0);

  return (
    <div className="min-h-screen flex">
      <Sidebar />
      <Layout>
        <div className="flex flex-col space-y-6 p-6">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
            <h2 className="text-white text-2xl font-bold">Product Analytics</h2>
            <button
              onClick={() => setRefreshKey(k => k + 1)}
              className="self-start sm:self-auto flex items-center gap-2 bg-[#FBB033] text-black px-3 py-1.5 rounded-md font-semibold hover:opacity-90 transition-opacity"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              Refresh Data
            </button>
          </div>

          <FilterBar
            employees={[]}
            onFilterChange={setFilters}
            showFrequencyFilter={false}
            defaultRangeType="today"
          />

          <div key={refreshKey} className="flex flex-col space-y-6">
            <ProductAnalyticsWidget filters={filters} />

            <DropoffExplorerWidget filters={filters} />

            {(can("analytics.locationBreakdown") && (
              <LocationBreakdownWidget filters={filters} />
            ))}

            <UserTimelineWidget />
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default AdminProductAnalytics;
